__turbopack_context__.v({
  "className": "montserrat_ad7abd69-module__Kd1I7W__className",
  "variable": "montserrat_ad7abd69-module__Kd1I7W__variable",
});
